import createIcon from '../../createIcon';

/**
 * @component @name BusinessCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTZWMTVIMy4wMUwzIDE5QzMgMjAuMTEgMy44OSAyMSA1IDIxSDE5QzIwLjExIDIxIDIxIDIwLjExIDIxIDE5VjE1SDE0VjE2SDEwWk0yMCA3SDE1Ljk5VjVMMTMuOTkgM0g5Ljk5TDcuOTkgNVY3SDRDMi45IDcgMiA3LjkgMiA5VjEyQzIgMTMuMTEgMi44OSAxNCA0IDE0SDEwVjEySDE0VjE0SDIwQzIxLjEgMTQgMjIgMTMuMSAyMiAxMlY5QzIyIDcuOSAyMS4xIDcgMjAgN1pNMTQgN0gxMFY1SDE0VjdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BusinessCenter = createIcon('BusinessCenter', [
  [
    'path',
    {
      d: 'M10 16V15H3.01L3 19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15H14V16H10ZM20 7H15.99V5L13.99 3H9.99L7.99 5V7H4C2.9 7 2 7.9 2 9V12C2 13.11 2.89 14 4 14H10V12H14V14H20C21.1 14 22 13.1 22 12V9C22 7.9 21.1 7 20 7ZM14 7H10V5H14V7Z',
      key: '1weyr1',
    },
  ],
]);

export default BusinessCenter;
